var AppState = /** @class */ (function () {
    function AppState() {
        this._state = {};
    }
    Object.defineProperty(AppState.prototype, "state", {
        /**
         * Already return a clone of the current state.
         */
        get: function () {
            return this._state = this._clone(this._state);
        },
        /**
         * Never allow mutation
         */
        set: function (value) {
            throw new Error('do not mutate the `.state` directly');
        },
        enumerable: true,
        configurable: true
    });
    AppState.prototype.get = function (prop) {
        /**
         * Use our state getter for the clone.
         */
        var state = this.state;
        return state.hasOwnProperty(prop) ? state[prop] : state;
    };
    AppState.prototype.set = function (prop, value) {
        /**
         * Internally mutate our state.
         */
        return this._state[prop] = value;
    };
    AppState.prototype._clone = function (object) {
        /**
         * Simple object clone.
         */
        return JSON.parse(JSON.stringify(object));
    };
    return AppState;
}());
export { AppState };



// WEBPACK FOOTER //
// ./src/app/app.service.ts.pre-build-optimizer.js